import { render } from "./JobFullList.vue?vue&type=template&id=5a93083b&scoped=true"
import script from "./JobFullList.vue?vue&type=script&lang=js"
export * from "./JobFullList.vue?vue&type=script&lang=js"

import "./JobFullList.vue?vue&type=style&index=0&id=5a93083b&scoped=true&lang=css"

import exportComponent from "C:\\SeaFarer\\SeaFarer\\AMDTransportation_FE\\amd_transportation_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a93083b"]])

export default __exports__